import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentWrapper from "../../../Wrapper";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { ContentWithCardLoading } from "../../../../components/loading";
import GatewayNameSidePanel from "../../components/gateway-name-side-panel";
import { CustomSubHeader } from "../../../../components/subheader";
import { BlueGradientButton } from "../../../../components/button";
import { DeleteModal } from "../../../../components/modal";
import * as gatewayNameActions from "../../store/actions/gateway_name_list_actions";

const GATEWAY_NAME_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  CREATE: "CREATE",
};

export default function GatewayNameList() {
  const [selectedGatewayNameWithAction, setSelectedGatewayAndPriceWithAction] = useState({
    action: GATEWAY_NAME_ACTIONS.NONE,
    data: {},
  });
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const gatewayNameList = useSelector((state) => state.gatewayName.gatewayNameList);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(gatewayNameActions.getListOfGatewayNameRequest({ limit: limit, page: pageNo }));
  }, [dispatch, limit, pageNo]);

  return (
    <ContentWrapper
      subHeader={
        <CustomSubHeader>
          <div className="d-flex flex-stack w-100 justify-content-end">
            <BlueGradientButton size="sm" onClick={() => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.CREATE })}>
              + Create Gateway Name
            </BlueGradientButton>
          </div>
        </CustomSubHeader>
      }
    >
      {gatewayNameList.loading ? (
        <ContentWithCardLoading />
      ) : gatewayNameList.data.length === 0 ? (
        "No gateways"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() => {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Gateway Name", apiKeyName: "gatewayName", fieldInputType: "INPUT" },
                { title: "Description", apiKeyName: "description", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit", "delete"] },
              ]}
              data={gatewayNameList.data}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={gatewayNameList.count}
              // actions
              handleEdit={(data) => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.EDIT, data })}
              handleDelete={(data) => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.DELETE, data })}
            />
          </div>
        </div>
      )}

      <GatewayNameSidePanel
        show={selectedGatewayNameWithAction.action === GATEWAY_NAME_ACTIONS.EDIT || selectedGatewayNameWithAction.action === GATEWAY_NAME_ACTIONS.CREATE}
        action={selectedGatewayNameWithAction.action}
        GATEWAY_NAME_ACTIONS={GATEWAY_NAME_ACTIONS}
        gatewayNameData={selectedGatewayNameWithAction.data}
        loadingData={{ limit, page: pageNo }}
        // acitons
        handleClose={() => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.NONE, data: {} })}
      />
      <DeleteModal
        modalProps={{
          show: selectedGatewayNameWithAction.action === GATEWAY_NAME_ACTIONS.DELETE,
          title: "Delete Gateway Name",
          handleClose: () => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.NONE, data: {} }),
          handleAccept: () => {
            const payload = { id: selectedGatewayNameWithAction.data._id };
            dispatch(gatewayNameActions.deleteGatewayNameRequest(payload));
            setSelectedGatewayAndPriceWithAction({ action: GATEWAY_NAME_ACTIONS.NONE, data: {} });
          },
        }}
      >
        Are you sure want to delete this Gateway Name?
      </DeleteModal>
    </ContentWrapper>
  );
}
